import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { WhoCanApply } from "./components/WhoCanApply";
import { Gallery } from "./components/gallery";
// import { Testimonials } from "./components/testimonials";
// import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { Footer } from "./components/Footer";
import JsonData from "./data/data.json";
// import SmoothScroll from "smooth-scroll";
import "./style.css";
import { Mission } from "./components/Mission";
import { Partnerships } from "./components/partnerships";
import { NavigationJumbo } from "./components/navigationJumbo";
import { HeaderJumbo } from "./components/headerJumbo";
import { FeaturesJumbo } from "./components/featuresJumbo";

// export const scroll = new SmoothScroll('a[href*="#"]', {
//   speed: 1000,
//   speedAsDuration: true,
// });

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />

      <HeaderJumbo data={landingPageData.Header} />

      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <WhoCanApply data={landingPageData.WhoCanApply} />
      <Gallery data={landingPageData.Gallery} />
      <Partnerships />

      <Mission />

      <Contact data={landingPageData.Contact} />
      <Footer />
    </div>
  );
};

export default Home;
